<template>
  <div class="system-home">
    <div class="header">系统首页</div>
    <div class="main">
      <div class="summary-order-message" ref="summary-order-message">
        <!-- 整体概述、带订单处理 -->
        <div class="summary-order">
          <div class="summary">
            <p class="title">整体概况</p>
            <div class="summary-container">
              <ul class="svg">
                <li>
                  <svg class="icon">
                    <use xlink:href="#icon-系统首页-订单" />
                  </svg>
                  <span>订单数</span>
                </li>
                <li>
                  <svg class="icon">
                    <use xlink:href="#icon-系统首页-金额" />
                  </svg>
                  <span>金额</span>
                </li>
              </ul>
              <div class="day">
                <p class="math">今日</p>
                <ul>
                  <li>
                    <p class="pTop">{{ whole.day.dayCountNum }}</p>
                    <p class="pBottom">
                      <span>环比昨日</span>
                      <span
                        :class="whole.day.dayCountUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.day.dayCountUpDown }}</span>
                    </p>
                  </li>
                  <li>
                    <p class="pTop">{{ whole.day.daySumPrice }}</p>
                    <p class="pBottom">
                      <span>环比昨日</span>
                      <span
                        :class="whole.day.daySumUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.day.daySumUpDown }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="week">
                <p class="math">本周</p>
                <ul>
                  <li>
                    <p class="pTop">{{ whole.week.weekCountNum }}</p>
                    <p class="pBottom">
                      <span>环比上周</span>
                      <span
                        :class="whole.week.weekCountUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.week.weekCountUpDown }}</span>
                    </p>
                  </li>
                  <li>
                    <p class="pTop">{{ whole.week.weekSumPrice }}</p>
                    <p class="pBottom">
                      <span>环比上周</span>
                      <span
                        :class="whole.week.weekSumUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.week.weekSumUpDown }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="month">
                <p class="math">本月</p>
                <ul>
                  <li>
                    <p class="pTop">{{ whole.month.monthCountNum }}</p>
                    <p class="pBottom">
                      <span>环比上月</span>
                      <span
                        :class="whole.month.monthCountUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.month.monthCountUpDown }}</span>
                    </p>
                  </li>
                  <li>
                    <p class="pTop">{{ whole.month.monthSumPrice }}</p>
                    <p class="pBottom">
                      <span>环比上月</span>
                      <span
                        :class="whole.month.monthSumUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.month.monthSumUpDown }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="year">
                <p class="math">本年</p>
                <ul>
                  <li>
                    <p class="pTop">{{ whole.year.yearCountNum }}</p>
                    <p class="pBottom">
                      <span>环比上年</span>
                      <span
                        :class="whole.year.yearCountUpDown.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.year.yearCountUpDown }}</span>
                    </p>
                  </li>
                  <li>
                    <p class="pTop">{{ whole.year.yearSumPrice }}</p>
                    <p class="pBottom">
                      <span>环比上年</span>
                      <span
                        :class="whole.year.yearSumUpDownRes.slice(0, 1) === '+'?'blue':'red'"
                      >{{ whole.year.yearSumUpDownRes }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="order">
            <p class="title">待处理订单</p>
            <div class="order-container">
              <ul>
                <li>
                  <span @click="goOrder(1)">{{ untreated.examine }}</span>
                  <p>待审核</p>
                </li>
                <li>
                  <span @click="goOrder(7)">{{ untreated.deliver }}</span>
                  <p>待发货</p>
                </li>
                <li>
                  <span @click="goOrderReturn(0)">{{ untreated.backExamine }}</span>
                  <p>待退货审核</p>
                </li>
                <li>
                  <span @click="goOrderReturn(2)">{{ untreated.refundReceipt }}</span>
                  <p>待退货确认</p>
                </li>
                <li>
                  <span @click="goOrderReturn(3)">{{ untreated.refund }}</span>
                  <p>待退款</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 通知信息 -->
        <div class="message">
          <p class="title">通知消息</p>
          <ul class="message-lists">
            <li v-for="(value,index) in messageData" :key="index" @click="goToMessage">
              <div class="title-time">
                <p class="message-title">
                  <svg
                    v-if="value.type === 1"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="16798"
                    width="20"
                    height="20"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M510.293333 938.666667c235.52 0 426.666667-191.146667 426.666667-426.666667s-191.146667-426.666667-426.666667-426.666667-426.666667 191.146667-426.666666 426.666667 191.146667 426.666667 426.666666 426.666667z m-29.013333-649.386667h129.706667c17.92 0 31.573333 14.506667 31.573333 31.573333 0 17.92-14.506667 31.573333-31.573333 31.573334H481.28c-68.266667 0-122.88 55.466667-122.88 122.88 0 68.266667 55.466667 122.88 122.88 122.88H537.6v-37.546667c0-26.453333 28.16-42.666667 51.2-29.866667l122.026667 69.12c23.04 12.8 23.04 46.08 0 59.733334L588.8 728.746667c-23.04 12.8-51.2-3.413333-51.2-29.866667v-37.546667h-56.32c-103.253333 0-186.88-83.626667-186.88-186.88-0.853333-101.546667 83.626667-185.173333 186.88-185.173333z"
                      fill="#2F89FC"
                      p-id="16799"
                    />
                  </svg>
                  <svg
                    v-if="value.type === 2"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="16970"
                    width="20"
                    height="20"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M506.88 85.333333c-235.52 0-426.666667 191.146667-426.666667 426.666667s191.146667 426.666667 426.666667 426.666667 426.666667-191.146667 426.666667-426.666667-191.146667-426.666667-426.666667-426.666667z m202.24 362.666667c0 17.066667-13.653333 30.72-30.72 30.72H538.453333v74.24h139.946667c17.066667 0 30.72 13.653333 30.72 30.72v2.56c0 17.066667-13.653333 30.72-30.72 30.72H538.453333v118.613333c0 17.066667-13.653333 30.72-30.72 30.72h-2.56c-17.066667 0-30.72-13.653333-30.72-30.72V616.96H335.36c-17.066667 0-30.72-13.653333-30.72-30.72v-2.56c0-17.066667 13.653333-30.72 30.72-30.72h139.946667v-74.24H335.36c-17.066667 0-30.72-13.653333-30.72-30.72v-2.56c0-17.066667 13.653333-30.72 30.72-30.72h106.666667l-102.4-102.4c-11.946667-11.946667-11.946667-31.573333 0-43.52l1.706666-1.706667c11.946667-11.946667 31.573333-11.946667 43.52 0l121.173334 121.173334 121.173333-121.173334c11.946667-11.946667 31.573333-11.946667 43.52 0l1.706667 1.706667c11.946667 11.946667 11.946667 31.573333 0 43.52l-102.4 102.4h108.373333c17.066667 0 30.72 13.653333 30.72 30.72v2.56z"
                      fill="#FE9358"
                      p-id="16971"
                    />
                  </svg>
                  <svg
                    v-if="value.type === 3"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="17188"
                    width="20"
                    height="20"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M504.32 85.333333c-235.52 0-426.666667 191.146667-426.666667 426.666667s191.146667 426.666667 426.666667 426.666667 426.666667-191.146667 426.666667-426.666667-190.293333-426.666667-426.666667-426.666667z m29.866667 649.386667H404.48c-17.92 0-31.573333-14.506667-31.573333-31.573333 0-17.92 14.506667-31.573333 31.573333-31.573334h129.706667c68.266667 0 122.88-55.466667 122.88-122.88 0-68.266667-55.466667-122.88-122.88-122.88H477.866667v37.546667c0 26.453333-28.16 42.666667-51.2 29.866667l-122.026667-69.12c-23.04-12.8-23.04-46.08 0-59.733334L426.666667 295.253333c23.04-12.8 51.2 3.413333 51.2 29.866667v37.546667h56.32c103.253333 0 186.88 83.626667 186.88 186.88 0 101.546667-83.626667 185.173333-186.88 185.173333z"
                      fill="#606173"
                      p-id="17189"
                    />
                  </svg>
                  <svg
                    v-if="value.type === 4"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="1977"
                    width="20"
                    height="20"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M506.88 79.36c-235.52 0-426.666667 191.146667-426.666667 426.666667s191.146667 426.666667 426.666667 426.666666 426.666667-191.146667 426.666667-426.666666c0-236.373333-191.146667-426.666667-426.666667-426.666667z m356.693333 520.533333l-110.933333 58.88c-5.973333 3.413333-11.946667 4.266667-17.92 4.266667-3.413333 0-7.68-0.853333-11.093333-1.706667-9.386667-2.56-17.92-9.386667-23.04-18.773333l-58.88-110.933333c-7.68-14.506667-2.56-32.426667 11.946666-40.106667 14.506667-7.68 32.426667-2.56 40.106667 11.946667l31.573333 59.733333c5.12-18.773333 7.68-37.546667 7.68-57.173333 0-124.586667-101.546667-226.133333-226.133333-226.133334S280.746667 381.44 280.746667 506.026667s101.546667 226.133333 226.133333 226.133333c28.16 0 55.466667-5.12 81.066667-14.506667 15.36-5.973333 32.426667 1.706667 38.4 17.066667 5.973333 15.36-1.706667 32.426667-17.066667 38.4-32.426667 12.8-67.413333 18.773333-102.4 18.773333-157.866667 0-285.866667-128-285.866667-285.866666s128-285.866667 285.866667-285.866667 285.866667 128 285.866667 285.866667c0 23.04-2.56 46.08-8.533334 68.266666l51.2-27.306666c14.506667-7.68 32.426667-2.56 40.106667 11.946666s2.56 33.28-11.946667 40.96zM514.56 407.04c-0.853333-1.706667-2.56-2.56-4.266667-2.56H443.733333v-17.066667h116.053334c2.56 0 5.12 0.853333 7.68 3.413334 1.706667 1.706667 3.413333 4.266667 3.413333 7.68v2.56l-51.2 221.013333H460.8l54.613333-210.773333c0-0.853333 0-2.56-0.853333-4.266667z"
                      fill="#FEC25B"
                      p-id="1978"
                    />
                  </svg>
                  <svg
                    v-if="value.type === 5"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="17406"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M505.173333 85.333333c-235.52 0-426.666667 191.146667-426.666666 426.666667s191.146667 426.666667 426.666666 426.666667 426.666667-191.146667 426.666667-426.666667-191.146667-426.666667-426.666667-426.666667z m-63.146666 664.746667h-51.2c-14.506667 0-25.6-11.946667-25.6-25.6 0-14.506667 11.946667-25.6 25.6-25.6h51.2c14.506667 0 25.6 11.946667 25.6 25.6 0 14.506667-11.093333 25.6-25.6 25.6z m63.146666-64c-14.506667 0-25.6-11.946667-25.6-25.6 0-14.506667 11.946667-25.6 25.6-25.6 14.506667 0 25.6 11.946667 25.6 25.6 0 14.506667-11.946667 25.6-25.6 25.6z m25.6-108.373333c0 14.506667-11.946667 25.6-25.6 25.6-14.506667 0-25.6-11.946667-25.6-25.6V453.973333c0-14.506667 11.946667-25.6 25.6-25.6 14.506667 0 25.6 11.946667 25.6 25.6v123.733334z m86.186667 172.373333h-51.2c-14.506667 0-25.6-11.946667-25.6-25.6 0-14.506667 11.946667-25.6 25.6-25.6h51.2c14.506667 0 25.6 11.946667 25.6 25.6 0 14.506667-11.946667 25.6-25.6 25.6z m135.68-25.6c0 16.213333-13.653333 29.866667-29.866667 29.866667s-29.866667-13.653333-29.866666-29.866667V446.293333l-187.733334-116.053333-187.733333 116.053333v278.186667c0 16.213333-13.653333 29.866667-29.866667 29.866667s-29.866667-13.653333-29.866666-29.866667V441.173333c0-17.066667 9.386667-34.133333 23.893333-42.666666l197.12-121.173334c16.213333-10.24 36.693333-10.24 52.906667 0l197.12 121.173334c14.506667 9.386667 23.893333 25.6 23.893333 42.666666v283.306667z"
                      fill="#FE5B67"
                      p-id="17407"
                    />
                  </svg>
                  <span>{{value.title}}</span>
                </p>
                <span class="time">{{value.time}}</span>
              </div>
              <p class="content">{{value.content}}</p>
            </li>
            <p class="more" @click="goToMessage">查看更多&gt;&gt;</p>
          </ul>
        </div>
      </div>
      <div class="other-reminder" ref="other-reminder">
        <!-- 其它 -->
        <div class="other">
          <p class="title">其他</p>
          <div class="other-container">
            <ul class="svg">
              <li>
                <svg class="icon">
                  <use xlink:href="#icon-系统首页-购物" />
                </svg>
                <span>商品</span>
              </li>
              <li>
                <svg class="icon">
                  <use xlink:href="#icon-系统首页-客户" />
                </svg>
                <span>客户</span>
              </li>
            </ul>
            <div class="content">
              <ul class="shangpin">
                <li>
                  <p>上架商品</p>
                  <span>{{ goods.upGoods }}</span>
                </li>
                <li>
                  <p>下架商品</p>
                  <span>{{ goods.downGoods }}</span>
                </li>
                <li>
                  <p>全部商品</p>
                  <span>{{ goods.allGoods }}</span>
                </li>
              </ul>
              <ul class="kehu">
                <li>
                  <p>今日新增</p>
                  <span>{{ customer.today }}</span>
                </li>
                <li>
                  <p>本月新增</p>
                  <span>{{ customer.month }}</span>
                </li>
                <li>
                  <p>客户总数</p>
                  <span>{{ customer.all }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 重要提醒 -->
        <div class="reminder">
          <p class="title">重要提醒</p>
          <div class="reminder-container">
            <div class="reminder-top">
              <div
                class="reminder-client"
                @click="goWraningPage('/admin/client/client-manage-index/client-manage?status=0')"
              >
                <span class="number">{{warn.countNoExamineCustomer}}</span>
                <span class="name">客户审核</span>
              </div>
              <div
                class="reminder-coupon"
                @click="goWraningPage('/admin/marketing/coupon/coupon-list?status=500')"
              >
                <span class="number">{{warn.countCouponTimeOut}}</span>
                <span class="name">优惠券到期</span>
              </div>
            </div>
            <div class="reminder-bottom">
              <div
                class="reminder-goods"
                @click="goWraningPage('/admin/commodity/list/commodity-list?sellOut=1')"
              >
                <span class="number">{{warn.countGoodsSaleOut}}</span>
                <span class="name">商品售罄</span>
              </div>
              <div class="reminder-text">
                <span class="number">{{warn.countUnUseSms}}</span>
                <span class="name">短信剩余</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import DBHome from "models/db/home.js";
const dbHome = new DBHome();
import { getDBOperationPermission } from "common/js/storage";
const ROLE_INDEX_SYSTEM = "ROLE_INDEX_system";
export default {
  data() {
    return {
      // 整体概述月周日
      whole: {
        week: {
          weekCountNum: "",
          weekSumUpDown: "",
          weekSumPrice: "",
          weekCountUpDown: "",
        },
        month: {
          monthCountNum: "",
          monthCountUpDown: "",
          monthSumUpDown: "",
          monthSumPrice: "",
        },
        day: {
          daySumPrice: "",
          dayCountUpDown: "",
          daySumUpDown: "",
          dayCountNum: "",
        },
        year: {
          yearSumPrice: "",
          yearCountUpDown: "",
          yearSumUpDownRes: "",
          yearCountNum: "",
        },
      },
      // 待处理订单数据
      untreated: {
        examine: 0, // 待审核订单
        deliver: 0, // 待发货订单
        backExamine: 0, // 待退货审核订单
        refundReceipt: 0, // 待退款收货订单
        refund: 0, // 待退款订单
      },
      // 其他商品数量
      goods: {
        downGoods: "",
        allGoods: "",
        upGoods: "",
      },
      // 其他客户数量
      customer: {
        all: "",
        month: "",
        today: "",
      },
      // 重要提醒数据
      warn: {
        countNoExamineCustomer: 0,
        countCouponTimeOut: 0,
        countGoodsSaleOut: 0,
        countUnUseSms: 0,
      },
      // 消息列表
      messageData: [],
    };
  },
  created() {
    if (getDBOperationPermission().findIndex(item => item === ROLE_INDEX_SYSTEM) !== -1) {
      this.getOrderCount();
      this.getOrderUntreated();
      this.getGoods();
      this.getCustomer();
      this.getWarningData();
      this.getMessageData();
    }
  },
  methods: {
    // 获取整体概述月周日
    getOrderCount() {
      dbHome.postDBOrderCount().then((res) => {
        if (res.success) {
          this.whole = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取待处理订单数据
    getOrderUntreated() {
      dbHome.getDBOrderUntreated().then((res) => {
        if (res.success) {
          this.untreated.examine = res.result.statusNoOrderExamine;
          this.untreated.deliver = res.result.statusNoExpress;
          this.untreated.backExamine = res.result.refundStatusNoExamine;
          this.untreated.refundReceipt = res.result.refundStatusNoReceivedGoods;
          this.untreated.refund = res.result.refundStatusNoRefundMoney;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取消息通知
    getMessageData() {
      let currentPage = 1;
      dbHome.getDBNotice(currentPage).then((res) => {
        console.log(res);
        if (res.success) {
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.time = this.toTime(value.createTime);
            obj.type = value.type;
            if (value.type === 1) {
              obj.title = "客户发起订单";
              obj.content = `客户${
                value.username ? value.username : " "
              }发起了订单，订单号：${value.content}`;
            } else if (value.type === 2) {
              obj.title = "客户支付";
              obj.content = `客户${
                value.username ? value.username : " "
              }已成功支付订单${value.content}，请尽快处理`;
            } else if (value.type === 3) {
              obj.title = "客户发起退单";
              obj.content = `客户${
                value.username ? value.username : " "
              }发起了退单，退单号：${value.content}`;
            } else if (value.type === 4) {
              obj.title = "客户已退货";
              obj.content = `退单${value.content}已经退货，请及时处理。`;
            } else if (value.type === 5) {
              obj.title = "商品售罄";
              obj.content = `编号为${value.content}的商品即将售罄，请注意库存变化，以免错过商机。`;
            }
            arr.push(obj);
          });
          if (arr.length > 6) {
            this.messageData = arr.slice(0, 6);
          } else {
            this.messageData = arr;
          }
        }
      });
    },
    // 获取待商品数据
    getGoods() {
      dbHome.getDBGoods().then((res) => {
        if (res.success) {
          this.goods = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取重要提示数据
    getWarningData() {
      dbHome.postDBSmsNumber().then((res) => {
        if (res.success) {
          this.warn.countNoExamineCustomer = res.result.countNoExamineCustomer;
          this.warn.countCouponTimeOut = res.result.countCouponTimeOut;
          this.warn.countGoodsSaleOut = res.result.countGoodsSaleOut;
          this.warn.countUnUseSms = res.result.countUnUseSms;
          console.log(res);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取待客户数据
    getCustomer() {
      dbHome.getDBCustomer().then((res) => {
        if (res.success) {
          this.customer = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 点击待处理订单数字进行跳转
    // 跳转订单页面
    goOrder(status) {
      this.$router.push({
        path: "/admin/order/order-form/order-list",
        query: {
          status,
        },
      });
    },
    // 跳转退单页面
    goOrderReturn(status) {
      this.$router.push({
        path: "/admin/order/return-form/order-return",
        query: {
          status,
        },
      });
    },
    // 重要提醒页面跳转
    goWraningPage(path) {
      this.$router.push(path);
    },
    // 消息通知
    goToMessage() {
      this.$router.push("/admin/home/message");
    },
    toTime(time) {
      let date = new Date(time);
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let detailDate = date.getDate();
      detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      return `${month}-${detailDate}  ${hour}:${minute}:${second}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.system-home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  letter-spacing: 1px;
  .header {
    height: 40px;
    background: #ebedf1;
    line-height: 40px;
    border-left: 1px solid #f5f7fa;
    text-align: left;
    font-size: 16px;
    font-family: "PingFangSC-Regular";
    padding-left: 20px;
  }
  .main {
    height: 100%;
    padding: 16px;
    overflow: auto;
    letter-spacing: 1px;
    .title {
      height: 24px;
      font-size: 16px;
      line-height: 24px;
      color: #303133;
      font-weight: bold;
      letter-spacing: 1px;
    }
    .icon {
      width: 36px;
      height: 36px;
    }
    .summary-order-message {
      height: 442px;
      margin-bottom: 16px;
      display: flex;
      .summary-order {
        height: 100%;
        flex: 2;
        margin-right: 16px;
        display: flex;
        flex-direction: column;
        .summary {
          height: 226px;
          background-color: #fff;
          margin-bottom: 16px;
          box-sizing: border-box;
          padding: 10px 22px 10px 10px;
          box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
          .summary-container {
            display: flex;
            .svg {
              width: 160px;
              padding-top: 10px;
              li {
                height: 76px;
                padding-right: 10px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                span {
                  font-size: 12px;
                  color: rgba(96, 98, 102, 1);
                  line-height: 16px;
                }
              }
            }
          }
          .day,
          .week,
          .month,
          .year {
            flex: 1;
            font-size: 14px;
            color: #606266;
            display: flex;
            flex-direction: column;
            .math {
              line-height: 24px;
              font-size: 14px;
            }
            ul {
              display: flex;
              flex-direction: column;
              flex: 1;
              li {
                flex: 1;
                padding-top: 12px;
                padding-bottom: 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .pTop {
                  font-size: 24px;
                  line-height: 24px;
                  font-family: ArialMT;
                  margin-bottom: 2px;
                }
                .pBottom {
                  height: 20px;
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(96, 98, 102, 1);
                  line-height: 20px;
                  .blue {
                    color: #3d74f2;
                  }
                  .red {
                    color: #df3445;
                  }
                }
              }
            }
          }
        }
        .order {
          flex: 1;
          background-color: #fff;
          box-sizing: border-box;
          padding: 10px;
          box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          .order-container {
            padding-top: 10px;
            flex: 1;
            ul {
              display: flex;
              li {
                flex: 1;
                height: 100px;
                padding-top: 40px;
                display: flex;
                flex-direction: column;
                color: #606266;
                font-size: 14px;
                letter-spacing: 1px;
                align-items: center;
                span {
                  color: #3d74f2;
                  font-size: 40px;
                  line-height: 48px;
                  cursor: pointer;
                }
                p {
                  margin-top: 7px;
                  font-size: 12px;
                  color: rgba(96, 98, 102, 1);
                  line-height: 20px;
                }
              }
            }
          }
        }
      }
      .message {
        height: 100%;
        flex: 1;
        background-color: #fff;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        .message-lists {
          padding: 10px 6px 0 6px;
          color: #606266;
          letter-spacing: 1px;
          height: 390px;
          overflow: auto;
          li {
            cursor: pointer;
            box-sizing: border-box;
            padding: 12px 7px 8px 7px;
            border-bottom: 1px solid #e6ebf0;
            .title-time {
              height: 12px;
              color: #000000;
              font-family: "ArialMT";
              margin-bottom: 8px;
              font-size: 12px;
              display: flex;
              justify-content: space-between;
              padding: 0 1px;
              span {
                height: 12px;
                line-height: 12px;
              }
              .message-title {
                font-size: 14px;
                display: flex;
                align-items: center;
                svg {
                  margin-right: 5px;
                }
              }
              .time {
                color: #999;
              }
            }
            .content {
              font-size: 12px;
              line-height: 18px;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
          .more {
            height: 35px;
            font-size: 12px;
            line-height: 35px;
            color: #d7d7d7;
            cursor: pointer;
            text-align: center;
          }
        }
        .message-lists::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }
        .message-lists::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 7px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #ccc;
        }
        .message-lists::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background: #ededed;
        }
      }
    }
    .other-reminder {
      height: 200px;
      display: flex;
      .other {
        height: 100%;
        flex: 2;
        background-color: #fff;
        margin-right: 16px;
        padding: 10px 10px 16px 10px;
        box-sizing: border-box;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        .other-container {
          display: flex;
          .svg {
            width: 160px;
            li {
              padding-top: 10px;
              height: 76px;
              padding-right: 10px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              span {
                font-size: 12px;
                color: rgba(96, 98, 102, 1);
                line-height: 16px;
              }
            }
          }
          .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            ul {
              display: flex;
              margin-bottom: 18px;
              li {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                color: #606266;
                p {
                  line-height: 24px;
                  margin-bottom: 12px;
                  font-size: 16px;
                }
                span {
                  font-size: 24px;
                  line-height: 24px;
                  font-family: "ArialMT";
                }
              }
            }
          }
        }
      }
      .reminder {
        height: 100%;
        flex: 1;
        background-color: #fff;
        box-sizing: border-box;
        padding: 10px 14.5px;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        .reminder-container {
          .reminder-top {
            margin-top: 6px;
            display: flex;
            margin-bottom: 10px;
            .reminder-client {
              cursor: pointer;
              width: 140px;
              height: 68px;
              background: linear-gradient(
                90deg,
                rgba(254, 91, 103, 1) 0%,
                rgba(254, 127, 99, 1) 100%
              );
              border-radius: 4px;
              margin-left: 12px;
              margin-right: 20px;
              display: flex;
              flex-direction: column;
              color: #ffffff;
              align-items: center;
              .number {
                font-size: 16px;
                padding: 12px 0;
              }
              .name {
                font-size: 12px;
              }
            }
            .reminder-coupon {
              cursor: pointer;
              width: 140px;
              height: 68px;
              background: linear-gradient(
                90deg,
                rgba(127, 20, 254, 1) 0%,
                rgba(9, 179, 253, 1) 100%
              );
              border-radius: 4px;
              display: flex;
              flex-direction: column;
              color: #ffffff;
              align-items: center;
              .number {
                font-size: 16px;
                padding: 12px 0;
              }
              .name {
                font-size: 12px;
              }
            }
          }
          .reminder-bottom {
            display: flex;
            .reminder-goods {
              cursor: pointer;
              width: 140px;
              height: 68px;
              background: linear-gradient(
                90deg,
                rgba(254, 147, 88, 1) 0%,
                rgba(254, 202, 92, 1) 100%
              );
              border-radius: 4px;
              margin-left: 12px;
              margin-right: 20px;
              display: flex;
              flex-direction: column;
              color: #ffffff;
              align-items: center;
              .number {
                font-size: 16px;
                padding: 12px 0;
              }
              .name {
                font-size: 12px;
              }
            }
            .reminder-text {
              width: 140px;
              height: 68px;
              background: linear-gradient(
                90deg,
                rgba(96, 97, 115, 1) 0%,
                rgba(149, 152, 163, 1) 100%
              );
              border-radius: 4px;
              display: flex;
              flex-direction: column;
              color: #ffffff;
              align-items: center;
              .number {
                font-size: 16px;
                padding: 12px 0;
              }
              .name {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
